<template>
    <div ref="mapContainer" class="map-edit-container" :class="{ 'embed': embed }" >
        <l-map :zoom="zoom" :center="center" :bounds="mapBounds" ref="editMap" :options="{
            zoomControl: false,
            minZoom: 2,
            maxNativeZoom: 18,
            maxZoom: 24,
            editable: true,
        }" @click="getMapClickPosition" style="z-index: 19" :class="{'ios-tablet':isTabletIos}">
            <l-control-zoom position="topright"></l-control-zoom>
            <l-control-layers position="bottomright" :hideSingleBase="true" :collapsed="false"></l-control-layers>
            <div v-if="project.useICGC">
                <l-wms-tile-layer
                    v-for="layer in layers"
                    :key="layer.name"
                    :base-url="layer.url"
                    :layers="layer.layers"
                    :visible="layer.visible"
                    :name="layer.name"
                    layer-type="base"
                    :options="layer.options"
                />
                </div>
            <l-tile-layer v-for="tileProvider in availiableMapLayers" :key="tileProvider.name" :name="$t(tileProvider.name)"
                :visible="true" :url="tileProvider.url" :attribution="tileProvider.attribution"
                :layer-type="tileProvider.type" :options="tileProvider.options" />

            

            <div v-if="filteredItems.length">
                <div v-for="object in filteredItems" :key="object._id">
                    <div v-if="object.type != 'zone'">
                        <l-marker v-if="(!activeObject ||
                            object._id != activeObject._id) &&
                            object.location
                            " :lat-lng="object.location | toLatLon" @click="openObject(object)">
                            <l-icon :icon-size="dynamicSize" :icon-anchor="dynamicAnchor"
                                icon-url="/img/map-icons/00_point.svg" />

                            <!--<l-popup :options="popupOptions">
                                <div @click="openObject(object)">
                                    {{ object.title || object.description }}
                                </div>
                            </l-popup>-->
                            <l-tooltip :options="tooltipOptions">
                                {{ object.title || object.description }}
                            </l-tooltip>
                        </l-marker>

                        <l-marker v-if="!editionEnabled &&
                            activeObject &&
                            object._id == activeObject._id &&
                            object.location
                            " :lat-lng="object.location | toLatLon">
                            <l-icon :icon-size="dynamicSize" :icon-anchor="dynamicAnchor"
                                icon-url="/img/map-icons/00_punt_select.svg" />

                            <!--<l-popup :options="popupOptions">
                                <div @click="openObject(object)">
                                    {{ object.title || object.description }}
                                </div>
                            </l-popup>-->
                            <l-tooltip :options="tooltipOptions">
                                {{ object.title || object.description }}
                            </l-tooltip>
                        </l-marker>
                    </div>
                    <div v-else>
                        <l-polygon v-if="canDrawPolygon(object)" :lat-lngs="object.shape.coordinates | toLatLonFromArray
                            " :fillOpacity="0.7" :fillColor="'#eb2065'" :color="'#eb2065'">
                            <l-popup>
                                <div>
                                    {{ object.title || object.description }}
                                </div>
                            </l-popup></l-polygon>

                        <l-rectangle v-if="object.shape.type == 'rectangle' &&
                            (!activeObject ||
                                object._id != activeObject._id ||
                                !editionEnabled ||
                                (activeObject &&
                                    object._id != activeObject._id))
                            " :bounds="object.shape.coordinates | toLatLonFromArray
        " :fillOpacity="0.7" :fillColor="'#eb2065'" :color="'#eb2065'"><l-popup>
                                <div>
                                    {{ object.title || object.description }}
                                </div>
                            </l-popup></l-rectangle>
                        <l-circle v-if="object.shape.type == 'circle' &&
                            (!activeObject ||
                                object._id != activeObject._id ||
                                !editionEnabled ||
                                (activeObject &&
                                    object._id != activeObject._id))
                            " :lat-lng="object.shape.coordinates | toLatLonFromArray
        " :radius="object.shape.radius" :fillOpacity="0.7" :fillColor="'#eb2065'" :color="'#eb2065'"><l-popup>
                                <div>
                                    {{ object.title || object.description }}
                                </div>
                            </l-popup></l-circle>
                    </div>
                </div>
            </div>

            <div v-if="pointDraft">
                <l-marker :lat-lng="pointDraft.location | toLatLon" :key="pointDraft._id" :draggable="true"
                    @dragend="updateDraftPosition">
                    <l-icon :icon-size="dynamicSize" :icon-anchor="dynamicAnchor"
                        icon-url="/img/map-icons/00_point_edit.svg" />
                </l-marker>
            </div>
        </l-map>
    </div>
</template>

<script>
import AppPageError from '@/components/AppPageError';
import store from '@/store/index';
import _ from 'underscore';
import moment from 'moment';
import * as L from 'leaflet';
require('leaflet.path.drag');
require('leaflet-editable');
import { TILE_PROVIDERS, DEFAULT_TILE_PROVIDER,ICGC_WMS_LAYERS } from '@/lib/constants';
import {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    LControl,
    LControlLayers,
    LControlZoom,
    LCircle,
    LPolygon,
    LRectangle,
    LTooltip,
    LWMSTileLayer
} from 'vue2-leaflet';
import LProjectViewModalContent from '@/components/LProjectViewModalContent';
import LProjectObjectList from '@/components/LProjectObjectList';
import AppSearchBar from '@/components/AppSearchBar';
import { Document } from 'flexsearch';
import LProjectConfigurationComments from '@/components/LProjectConfigurationComments';
import LProjectSettingsComplete from '@/components/LProjectSettingsComplete';
import PlayQuiz from '@/components/PlayQuiz';
import PlayTreasureHunt from '@/components/PlayTreasureHunt';
import LProjectSessionCreation from '@/components/LProjectSessionCreation';
import tippy, { createSingleton } from 'tippy.js';
import LProjectObject from '@/components/LProjectObject';
import { isEmptyObject } from '@/lib/helpers';
import LProjectSessionsMenu from '@/components/LProjectSessionsMenu';
import LProjectSessionEdition from '@/components/LProjectSessionEdition';
// import 'leaflet-distortableimage/dist/vendor.js';
// import 'leaflet-distortableimage/dist/leaflet.distortableimage.js';
import LProjectZone from '@/components/LProjectZone';
import LProjectZoneObject from '@/components/LProjectZoneObject';
import LProjectConfigurationChanges from '@/components/LProjectConfigurationChanges';
import LProjectModalSessionCreation from '@/components/LProjectModalSessionCreation';
import { fetchItem, pauseSession, continueSession, stopSession } from '@/services/API';
import Swal from 'sweetalert2';
import LProjectActiveSession from '@/components/LProjectActiveSession';
import LProjectSessionsHistory from '@/components/LProjectSessionsHistory';
import ProjectSessionDetailsModal from '@/components/ProjectSessionDetailsModal';
import { isTablet,isMobileOnly,isAndroid,isIOS } from 'mobile-device-detect';

export default {
    name: 'ProjectEdit',
    components: {
        AppPageError,
        LMap,
        LTileLayer,
        LMarker,
        LIcon,
        LPopup,
        LControl,
        LControlLayers,
        LProjectViewModalContent,
        LProjectObjectList,
        AppSearchBar,
        LControlZoom,
        LProjectConfigurationComments,
        LProjectSettingsComplete,
        PlayQuiz,
        PlayTreasureHunt,
        LProjectSessionCreation,
        LProjectObject,
        LProjectSessionsMenu,
        LProjectSessionEdition,
        LProjectZone,
        LCircle,
        LPolygon,
        LRectangle,
        LProjectZoneObject,
        LProjectConfigurationChanges,
        LProjectModalSessionCreation,
        LProjectActiveSession,
        LProjectSessionsHistory,
        ProjectSessionDetailsModal,
        LTooltip,
        "l-wms-tile-layer": LWMSTileLayer,
    },

    data() {
        return {
            embed: this.$route.meta.embed,
            /* content */
            selectedItem: {},
            //items: this.$store.getters.projectContent || [],
            searchIndex: new Document({
                resolution: 3,
                tokenize: 'full',
                document: {
                    id: '_id',
                    index: [
                        {
                            field: 'title',
                            minlength: 0,
                        },
                        {
                            field: 'description',
                            minlength: 0,
                        },
                        {
                            field: 'tags',
                            minlength: 0,
                        },
                        'owner:name',
                        'owner:email',
                    ],
                },
            }),
            searchValue: '',
            contentDraft: { owner: {}, location: {} },
            //pointDraft: undefined,
            // creationEnabled: false,
            creating: false,
            // editionEnabled: false,
            // activeObject: undefined,
            originalMapProvider: '',
            activeSession: undefined,
            sessionEditionEnabled: false,
            originalOverlay: {
                image: {},
                opacity: 100,
            },
            zoneCreationEnabled: false,
            zoneDraft: { type: 'zone', owner: {} },
            settingsWizardEnabled: false,
            session: {},
            /* content */

            /* map */
            map: {},
            sidebar: {},
            typeFilter: this.$t('Constants.FILTER_OPTION_ALL'),
            layersPosition: 'topright',
            tileProviders: TILE_PROVIDERS,
            defaultTileProvider: DEFAULT_TILE_PROVIDER,
            token: 'your token if using mapbox',
            popupOptions: { offset: L.point(0, -30) },
            tooltipOptions: { permanent: false, className: 'pointLabel', direction: 'right', offset: L.point(15, -20) },
            iconSize: 32,
            zoom: 6,
            center: [40, -2],
            //mapPositionActive: false,
            NEmapPositionActive: false,
            SWmapPositionActive: false,
            NEpoint: undefined,
            SWpoint: undefined,
            overlayBounds: { southWest: {}, northEast: {} },
            // drawOverlayImage: false,
            overlayOpacity: 1,
            overlayImage: {},
            activeShape: {},
            /* map */

            /* project */
            showMessages: false,
            showSettings: false,
            showSimulateSessionModal: false,
            showErrorPage: false,
            showObjectModal: false,
            helpers: {},
            showSessions: false,
            activeTab: '',
            // showAdjustments: false,
            showHistory: false,
            /* project*/

            sessionStarted: false,
            sessionPaused: false,
            startingSession: false,

            eventSource: undefined,

            showActiveSession: false,
            showSessionList: false,
            showSessionDetails: false,

            isTabletIos: isTablet && isIOS,

            layers: ICGC_WMS_LAYERS,
        };
    },
    props: {
        projectId: { type: String, default: undefined },
        items: {
            type: Array,
            default: () => {
                return [];
            },
        },
        pointDraft: {
            type: Object,
            default: undefined
        },
        mapPositionActive: { type: Boolean, default: false },
        creationEnabled: { type: Boolean, default: false },
        editionEnabled: { type: Boolean, default: false },
        activeObject: { type: Object, default: {} },
        isViewMode: { type: Boolean, default: false }
    },
    filters: {
        toLatLon(location) {
            // console.log("location",location)
            let latLon = [location.latitude, location.longitude];
            // console.log(latLon);
            return latLon;
        },
        toLatLonFromArray(coordinates) {
            let transformed = [];
            if (Array.isArray(coordinates[0])) {
                for (let i = 0; i < coordinates[0].length; i++) {
                    transformed.push([
                        coordinates[0][i][1],
                        coordinates[0][i][0],
                    ]);
                }
            } else {
                transformed.push(coordinates[1], coordinates[0]);
            }
            return transformed;
        },
    },
    computed: {
        /* map */
        dynamicSize() {
            return [this.iconSize, this.iconSize * 1.15];
        },
        dynamicAnchor() {
            return [this.iconSize / 2, this.iconSize * 1.15];
        },
        mapBounds() {
            let bounds = [];
            if (this.projectType == 'scape' && this.hasOverlay) {
                bounds.push(this.project.overlay.corners);
            } else {
                if (this.filteredItems.length) {
                    // console.log("setting map bounds")
                    this.filteredItems.forEach((element) => {
                        // console.log(element.location);
                        if (element.type != 'zone') {
                            bounds.push(
                                this.$options.filters.toLatLon(element.location)
                            );
                            if (element.type != 'zone') {
                                bounds.push(
                                    this.$options.filters.toLatLon(element.location)
                                );
                                if (this.filteredItems.length < 2) {
                                    // console.log("adding new bound", element.location)
                                    let new_latitude = element.location.latitude + (0.10 / ((2 * Math.PI / 360) * 6378.137));
                                    let new_longitude = element.location.longitude + (0.10 / ((2 * Math.PI / 360) * 6378.137)) / Math.cos(element.location.latitude * Math.PI / 180);
                                    // console.log(new_latitude,new_longitude)
                                    bounds.push(
                                        this.$options.filters.toLatLon({ 'latitude': new_latitude, 'longitude': new_longitude })
                                    );
                                    let new_latitude2 = element.location.latitude - (0.10 / ((2 * Math.PI / 360) * 6378.137));
                                    let new_longitude2 = element.location.longitude - (0.10 / ((2 * Math.PI / 360) * 6378.137)) / Math.cos(element.location.latitude * Math.PI / 180);
                                    bounds.push(
                                        this.$options.filters.toLatLon({ 'latitude': new_latitude2, 'longitude': new_longitude2 })
                                    );
                                }
                            }
                        }
                    });
                } else {
                    bounds.push([40, -2], [40.5, -2.5]);
                    navigator.geolocation.getCurrentPosition((pos) => {
                        this.map.setView(new L.LatLng(pos.coords.latitude, pos.coords.longitude), 10);
                        
                    });
                    //console.log("geolocation is",this.center)
                }
            }
            // console.log('bounds', bounds);
            return L.latLngBounds(bounds);
        },
        mapProvider() {
            if (this.project.mapProvider) {
                return _.findWhere(this.tileProviders, {
                    name: this.project.mapProvider,
                });
            }
            return this.defaultTileProvider;
        },
        availiableMapLayers() {
            let layers = [];
            layers.push(this.mapProvider);
            let overlayLayers = _.where(this.tileProviders, {
                type: 'overlay',
            });
            overlayLayers.forEach(element => {
                layers.push(element);
            });

            // console.log(layers)
            return layers
        },
        /* map */

        /* content */
        projectType() {
            return this.$store.getters.project.type;
        },
        hasOverlay() {
            return (
                this.$store.getters.project.overlay &&
                this.$store.getters.project.overlay.image &&
                Object.keys(this.$store.getters.project.overlay.image).length >
                0
            );
        },
        hasObjects() {
            if (this.$store.getters.projectContent.length) {
                return true;
            }
            return false;
        },
        project() {
            return this.$store.getters.project;
        },
        filteredItems() {
            //console.log('filteredItems', this.$store.getters.projectContent);
            // return this.$store.getters.projectContent;
            if (!this.items.length && !this.searchValue) {
                this.items = this.$store.getters.projectContent;
            }
            let items;
            this.searchIndex.remove(this.items);
            items = this.items;
            // console.log('items', items);
            if (this.searchValue) {
                // console.log('searchValue', this.searchValue);
                this.searchIndex.add(items);
                // console.log('searchIndex', this.searchIndex);
                const result = this.searchIndex.search(this.searchValue);
                // console.log('result', result);
                const ids = _.chain(result).pluck('result').flatten().value();
                return this.items.filter((item) => {
                    return _.contains(ids, item._id);
                });
            }
            return items;
        },
        contentModel() {
            //console.log(this.projectType);
            if (this.projectType === 'trivial' || this.projectType === 'quizhunt') {
                // console.log(this.$store.getters.questionModel);
                return this.$store.getters.geoQuestionModel;
            } else {
                return this.$store.getters.markerModel;
            }
        },
        isScape() {
            return this.project.type == 'scape';
        },

        simulatedSession() {
            let sessionData = {
                configuration: {
                    mode: 'MAP',
                    time: 2,
                    timeUnits: 'minutes',
                    feedback: '',
                },
                project: this.$store.getters.project,
                title: `${this.$store.getters.project.title}`,
                allowsReset: false,
                session_answers: [],
                simulation: true,
            };
            if (this.$store.getters.project.type == 'treasurehunt') {
                // console.log('treasurehunt sumulation');
                let treasurehuntContent = [];
                let items = [...this.filteredItems];
                for (let item of items) {
                    // console.log(_.keys(item.triggers)[0]);
                    if (_.keys(item.triggers)[0] == 'GO_TO_POINT') {
                        /*console.log(
                            'search point',
                            item.triggers[_.keys(item.triggers)[0]]
                        );*/
                        let pointData = _.findWhere(items, {
                            _id: item.triggers[_.keys(item.triggers)[0]],
                        });
                        // console.log('pointData', pointData);
                        item.location = pointData.location;
                        item.triggers = pointData.triggers;
                        // console.log('item', item);
                        treasurehuntContent.push(item);
                    } else if (
                        _.keys(item.triggers)[0] != 'AT_ARRIVE' &&
                        _.keys(item.triggers)[0] != 'GO_TO_POINT'
                    ) {
                        if (item.triggers[_.keys(item.triggers)[0]] == '') {
                            item.triggers = { END: '' };
                        }
                        treasurehuntContent.push(item);
                    }
                }
                // console.log('treasure hunt content', treasurehuntContent);
                sessionData.context = treasurehuntContent;
            } else {
                sessionData.context = this.filteredItems;
            }
            return sessionData;
        },
        simulatePlayComponent() {
            if (this.$store.getters.project.type == 'treasurehunt') {
                return PlayTreasureHunt;
            } else {
                return PlayQuiz;
            }
        },
        /* content */

        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        isProjectAdmin() {
            return (
                this.$store.getters.isAdmin ||
                this.project.accessLevel == 'administrator'
            );
        },
        hasEditionPermission() {
            return (
                this.$store.getters.isLoggedIn &&
                this.$store.getters.project.accessLevel != 'read' &&
                this.$store.getters.project.accessLevel != 'create'
            );
        },
        showPlay() {
            return !this.sessionStarted;
        },
        showContinue() {
            return this.sessionStarted && this.sessionPaused;
        },
        showPause() {
            return this.sessionStarted && !this.sessionPaused;
        },
        showStop() {
            return this.sessionStarted;
        },

    },
    watch: {
        items: {
            handler: function () {
                this.items.forEach((item) => {
                    // console.log;
                    this.searchIndex.add(item);
                });
                //this.searchIndex.add(this.items)
            },
            immediate: true,
            deep: true,
        },
        project: {
            handler: function () {
                // console.log("in project handler")
                if (this.project.mapProvider) {
                    // console.log('HAS PROVIDER', this.project.mapProvider);
                    this.originalMapProvider = _.findWhere(this.tileProviders, {
                        name: this.project.mapProvider,
                    });
                } else {
                    this.originalMapProvider = this.defaultTileProvider;
                }

                if (
                    this.project.overlay &&
                    this.project.type == 'scape' &&
                    Object.keys(this.overlayImage).length === 0
                ) {
                    // console.log('setting original overlay');
                    this.originalOverlay = { ...this.project.overlay };
                }

                if (
                    this.project.overlay &&
                    this.project.overlay.image &&
                    this.project.overlay.corners &&
                    Object.keys(this.overlayImage).length === 0
                ) {
                    // console.log('drawing');
                    setTimeout(() => {
                        this.overlayImage = L.distortableImageOverlay(
                            this.project.overlay.image.url,
                            {
                                selected: false,
                                suppressToolbar: true,
                                mode: 'freeRotate',
                                actions: [L.FreeRotateAction],
                                corners: this.project.overlay.corners,
                                center: this.project.overlay.center,
                                angle: this.project.overlay.angle,
                                editable: false
                            }
                        ).addTo(this.map);
                    }, 500);


                    setTimeout(() => {
                        this.overlayOpacity = this.project.overlay.opacity;
                        this.overlayImage._image.style.opacity =
                            this.overlayOpacity / 100;
                        this.overlayImage.editing.disable();
                        this.overlayImage.on('edit', this.updateOverlayData);
                        this.overlayImage.on('dragend', this.updateOverlayData);

                        this.map.fitBounds(
                            L.latLngBounds(this.project.overlay.corners)
                        );
                    }, 500);
                }
                if (this.project.activeSession) {
                    // console.log("active session ID",this.project.activeSession)
                    if (!this.session || (this.session._id != this.project.activeSession)) {
                        // console.log("getting session")
                        this.fetchSession();
                    }

                }
            },
            immediate: true,
        },
        overlayOpacity: {
            handler: function () {
                if (this.overlayImage && this.overlayImage._image) {
                    this.overlayImage._image.style.opacity =
                        this.overlayOpacity / 100;
                }
            },
            immediate: true,
        },
        session: {
            //deep: true,
            handler: function () {
                // console.log("in session handler")
                if (this.session) {
                    if (!this.session.isArchived) {
                        // console.log("session not archived")
                        if (this.session.isActive) {
                            // console.log("session active")
                            this.sessionStarted = true;
                        } else {
                            this.sessionStarted = false;
                        }
                        if (this.session.isPaused) {
                            // console.log("session paused")
                            this.sessionPaused = true;
                        } else {
                            this.sessionPaused = false;
                        }
                    } else {
                        this.sessionPaused = false;
                        this.sessionStarted = false;
                    }
                }

            },
            immediate: true,
        },
        pointDraft: {
            handler: function () {
                if (this.pointDraft && !this.editionEnabled) {
                    // console.log(this.pointDraft)
                    this.map.setView(this.$options.filters.toLatLon(this.pointDraft.location), 19);
                    /*this.map.fitBounds(
                        L.latLngBounds([
                            this.$options.filters.toLatLon(this.pointDraft.location),
                        ])
                    );*/
                }
            },
            immediate: true,
            deep: true,
        },
        mapPositionActive: {
            handler: function () {
                if (this.mapPositionActive && !this.pointDraft) {
                    this.$refs.editMap.$el.classList.add('map-workshop-cursor');
                }
            },
            immediate: true,
        },
        /*editionEnabled:{
            handler: function () {
                if(this.editionEnabled){

                }
                console.log("edition enabled",this.editionEnabled)
            },
            immediate: true,
        }*/
    },
    mounted: function () {
            if(this.isViewMode){
                this.$refs['mapContainer'].classList.add("full-width-map")
            }
        /*store
            .dispatch('fetchProject', this.$route.params.projectId)
            .then(() => {
                    
                })
            .catch((e) => {
                console.error('failed to fetch project', e.status || e);
                this.showErrorPage = true;
            });

        setTimeout(() => {
            this.$Progress.start();
        }, 500);

        store
            .dispatch('fetchProjectContent', {
                _id: this.$route.params.projectId,
            })
            .catch(() => {
                console.error('failed to fetch project content');
            })
            .finally(() => {
                this.$Progress.finish();
                const projectDate = moment(
                    this.$store.getters.project.modified
                );
                const nowDate = moment();
                const diffMinutes = nowDate.diff(projectDate, 'minutes');
                //console.log(this.$store.getters.projectContent.length,diffMinutes,this.$store.getters.project.accessLevel == 'administrator')
                if (
                    !this.$store.getters.projectContent.length &&
                    diffMinutes < 2 &&
                    this.$store.getters.project.accessLevel == 'administrator'
                ) {
                    this.showSettings = true;
                }
                if (
                    !this.isLoggedIn &&
                    (this.project.privacy == 'secret' ||
                        this.project.privacy == 'public') &&
                    this.project.allowAnonymous
                ) {
                    // console.log('dispatching anonymous login');
                    this.$store
                        .dispatch('anonymousLogin', 'anonymous')
                        .then(() => {
                            // console.log(this.$store.getters.user);
                        });
                }
            });*/
        //setTimeout(() => {
        delete L.Icon.Default.prototype._getIconUrl;
        L.Icon.Default.mergeOptions({
            iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
            iconUrl: require('leaflet/dist/images/marker-icon.png'),
            shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
        });
        //}, 700);

        this.$nextTick(() => {
            if (this.$refs.editMap) {
                this.map = this.$refs.editMap.mapObject;
                /*this.sidebar = L.control
                    .sidebar({
                        autopan: false, // whether to maintain the centered map point when opening the sidebar
                        closeButton: true, // whether t add a close button to the panes
                        container: 'sidebar', // the DOM container or #ID of a predefined sidebar container that should be used
                        position: 'left', // left or right
                    })
                    .addTo(this.map);

                this.sidebar.on('closing', this.checkTab);
                this.sidebar.on('content', this.checkTab);
                */

                this.map.on('editable:drawing:start', this.initActiveShape);
                this.map.on('editable:drawing:end', this.setActiveShape);

                this.helpers = tippy('[data-helper-session]');
                const singleton = createSingleton(this.helpers, {
                    delay: 500,
                    moveTransition: 'transform 0.2s ease-out',
                    placement: 'right',
                    theme: 'tippylabylok',
                    allowHTML: true,
                });

                this.map.fitBounds(this.mapBounds)
            }

        });

        


    },
    beforeDestroy() {
        // this.eventSource.close();
    },
    destroyed() {
        /*this.$store.dispatch('cleanProject');
        if (
            this.$store.getters.isAnonymous &&
            (this.project.privacy == 'secret' ||
                this.project.privacy == 'public') &&
            this.project.allowAnonymous
        ) {
            this.$store.dispatch('logout');
        }*/
    },

    methods: {
        /* session related functions */
        startSimulation() {
            // console.log('in start simulation', this.simulatedSession);
            this.$store
                .dispatch('setSession', this.simulatedSession)
                .catch((e) => {
                    console.log('error setting simulation session');
                });
            this.showSimulateSessionModal = true;
        },
        mySessions() { },

        startSession() {
            // console.log("in start session")
            // this.sessionStarted = true;
            if (this.items.length) {
                this.startingSession = true;
            } else {
                // console.log("no items")
                Swal.fire({
                    text: this.$t('game_session_no_objects'),
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: this.$t('Buttons.return'),
                })
                return;
            }

        },
        pauseSession() {
            // console.log("pause session")
            pauseSession(this.session._id, this.session).then((res) => {
                this.fetchSession();
            });


        },
        continueSession() {
            // console.log("continue session")
            if (this.editionEnabled || this.creationEnabled) {
                return;
            }
            if (this.items.length) {
                continueSession(this.session._id, this.session).then((res) => {
                    this.fetchSession();
                });
            } else {
                // console.log("no items")
                Swal.fire({
                    text: this.$t('game_session_no_objects'),
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: this.$t('Buttons.return'),
                })
                return;
            }

        },
        stopSession() {
            // console.log("stop session");
            Swal.fire({
                //title: this.$t('delete_object_title'),
                text: this.$t('game_session_stop_warning'),
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.$t('userProfile.leave_school_continue'),
                cancelButtonText: this.$t('userProfile.leave_school_cancel'),
            }).then((result) => {
                if (result.isConfirmed) {
                    stopSession(this.session._id, this.session).then((res) => {
                        // this.fetchSession();
                        this.session = {};
                        this.$store.dispatch('cleanSession');
                    });
                }
            });



        },
        activateSession() {
            this.sessionStarted = true;
            this.session = this.$store.getters.session;
            this.showSessionDetails = true;
            //this.fetchSession();
        },

        async fetchSession() {
            // console.log("fetch session data")
            let sessionData = await fetchItem(
                'session',
                this.project.activeSession
            );
            this.$store.dispatch('setSession', sessionData.data);
            this.session = sessionData.data;
            // console.log("session data",sessionData.data,this.session)
        },
        /* async updateSession() {
             // console.log('session data', this.session);
             // console.log('projectContent', this.$store.getters.projectContent);
             // console.log('original context', [...this.session.context]);
             // this.saving = true;
             let newContext = [];
             this.session.context.forEach((element) => {
                 let updateObject = _.findWhere(
                     this.$store.getters.projectContent,
                     {
                         _id: element._id,
                     }
                 );
                 if (updateObject) {
                     let objectToInclude = { ...updateObject };
                     delete objectToInclude.watchers;
                     delete objectToInclude.likes;
                     delete objectToInclude.liked;
                     delete objectToInclude.accessLevel;
                     if (
                         objectToInclude.comments &&
                         objectToInclude.comments.length == 0
                     ) {
                         delete objectToInclude.comments;
                     }
                     newContext.push(objectToInclude);
                 } else {
                     newContext.push({ ...element });
                 }
             });
             //console.log(newContext);
             this.session.context = newContext;
             console.log('new session context', this.session.context);
             let response = await updateItem(
                 'session',
                 this.session._id,
                 this.session
             )
                 .then(() => {
                     this.$emit('close');
                     this.saving = false;
                 })
                 .catch(() => {
                     this.error = true;
                     this.saving = false;
                 });
         },*/
        /* session related functions */

        /* content */
        searchObjects(text) {
            this.searchValue = text;
            this.filteredItems;
        },
        openObject(object) {
            if (this.editionEnabled || this.creationEnabled) {
                return;
            }
            // console.log("opening object");
            this.$emit('show', object)
            /*this.activeObject = _.findWhere(this.filteredItems, {
                _id: object._id,
            });
            // this.activeMarker = object;
            this.showObjectModal = true;*/
        },
        setProjectMapProvider(provider) {
            this.project.mapProvider = provider.name;
        },
        /*enableCreation() {
            // console.log('in enable creation', this.creationEnabled);
            if (this.creationEnabled) {
                return;
            }
            // console.log('assigning draft');
            this.contentDraft._id = 'draft';
            this.contentDraft.order = this.items.length + 1;
            this.contentDraft.owner = this.$store.getters.user;
            // console.log(this.contentDraft);
            this.creationEnabled = true;
        },*/
        enableZoneCreation() {
            if (this.zoneCreationEnabled) {
                return;
            }
            this.zoneDraft._id = 'draft';
            this.zoneDraft.order = this.items.length + 1;
            this.zoneDraft.owner = this.$store.getters.user;
            this.zoneCreationEnabled = true;
        },
        /*async createObject() {
            // console.log('creating object', this.contentDraft);
            if (
                !isEmptyObject(
                    _.omit(this.contentDraft, '_id', 'order', 'owner')
                )
            ) {
                if (this.creating == true) {
                    // console.log('cancelling input because  is creating');
                    return this.cancelInput();
                }

                this.creating = true;
                if (this.items.length > 1) {
                    this.contentDraft.order = this.items.length;
                } else {
                    this.contentDraft.order = 1;
                }

                await this.$store
                    .dispatch('createObject', {
                        ...this.contentDraft,
                        ...{ project: this.$route.params.projectId },
                    })
                    .catch((e) => {
                        console.error('error creatiorn', e);
                        this.creating = false;
                    });

                this.creating = false;
                this.showCreation = false;
                this.items = this.$store.getters.projectContent.filter(
                    function (item) {
                        return item['_id'] != 'draft';
                    }
                );
                this.pointDraft = undefined;
            } else {
                this.cancelInput();
            }
            this.creationEnabled = false;
            this.contentDraft = { owner: {}, location: {} };
            this.sidebar.close();
        },*/
        async createZone() {
            // console.log('creating zone', this.zoneDraft);

            if (this.creating == true) {
                // console.log('cancelling input because  is creating');
                return this.cancelInputZone();
            }

            this.creating = true;
            if (this.items.length > 1) {
                this.zoneDraft.order = this.items.length;
            } else {
                this.zoneDraft.order = 1;
            }

            await this.$store
                .dispatch('createObject', {
                    ...this.zoneDraft,
                    ...{ project: this.$route.params.projectId },
                })
                .catch((e) => {
                    console.error('error creatiorn', e);
                    this.creating = false;
                });

            this.creating = false;
            this.showCreation = false;
            this.items = this.$store.getters.projectContent.filter(function (
                item
            ) {
                return item['_id'] != 'draft';
            });
            this.creationEnabled = false;
            this.zoneDraft = { type: 'zone', owner: {} };
            this.map.removeLayer(this.activeShape);
            this.activeShape = {};
            this.sidebar.close();
        },
        /*cancelInput() {
            if (this.contentDraft._id == 'draft') {
                this.items = _.without(this.items, this.contentDraft);
            } else {
            }

            this.contentDraft = { owner: {}, location: {} };
            this.pointDraft = undefined;
            // this.originalItem = {};
            this.showCreation = false;
            this.creationEnabled = false;
            this.sidebar.close();
        },*/

        /*editObject() {
            // console.log('in edition');
            this.showObjectModal = false;
            this.creationEnabled = false;
            this.sidebar.close();

            if (this.activeObject.type == 'zone') {
                this.sidebar.disablePanel('new-zone');
                this.sidebar.enablePanel('edit-zone');
                this.zoneDraft = { ...this.activeObject };
                this.editionEnabled = true;
                console.log('zone activeObject');
                setTimeout(() => {
                    if (this.zoneDraft.shape.type == 'circle') {
                        console.log('circle');
                        this.activeShape = L.circle(
                            this.$options.filters.toLatLonFromArray(
                                this.zoneDraft.shape.coordinates
                            ),
                            this.zoneDraft.shape.radius
                        ).addTo(this.map);
                    } else if (this.zoneDraft.shape.type == 'rectangle') {
                        console.log('rectangle');
                        this.activeShape = L.rectangle(
                            this.$options.filters.toLatLonFromArray(
                                this.zoneDraft.shape.coordinates
                            )
                        ).addTo(this.map);
                    } else if (this.zoneDraft.shape.type == 'polygon') {
                        console.log('polygon');
                        this.activeShape = L.polygon(
                            this.$options.filters.toLatLonFromArray(
                                this.zoneDraft.shape.coordinates
                            )
                        ).addTo(this.map);
                    }
                    this.activeShape.enableEdit();
                    console.log(this.activeShape);
                    console.log(this.activeObject);
                    this.sidebar.open('edit-zone');
                }, 500);
            } else {
                this.sidebar.disablePanel('new-object');
                this.sidebar.enablePanel('edit-object');
                this.contentDraft = { ...this.activeObject };
                this.editionEnabled = true;
                setTimeout(() => {
                    this.sidebar.open('edit-object');
                    this.pointDraft = {
                        location: {
                            latitude: this.contentDraft.location.latitude,
                            longitude: this.contentDraft.location.longitude,
                        },
                    };
                }, 500);
            }
        },*/

        /*async updateObject() {
            // console.log('in updateObject');
            let editedObject = await this.$store.dispatch('updateObject', {
                ...this.contentDraft,
            });
            if (editedObject) {
                // console.log(editedObject);
                const objectIndex = _.findIndex(this.items, {
                    _id: editedObject._id,
                });
                this.items.splice(objectIndex, 1, editedObject);
                this.sidebar.close();
                this.editionEnabled = false;
                this.pointDraft = undefined;
                this.contentDraft = { owner: {}, location: {} };
                this.activeObject = undefined;
                this.sidebar.enablePanel('new-object');
                this.sidebar.disablePanel('edit-object');
            }
        },*/

        /*async updateZone() {
            console.log('updating zone', this.zoneDraft);

            let editedObject = await this.$store
                .dispatch('updateObject', {
                    ...this.zoneDraft,
                    ...{ project: this.$route.params.projectId },
                })
                .catch((e) => {
                    console.error('error creatiorn', e);
                    this.creating = false;
                });

            if (editedObject) {
                // console.log(editedObject);
                const objectIndex = _.findIndex(this.items, {
                    _id: editedObject._id,
                });
                this.items.splice(objectIndex, 1, editedObject);

                this.editionEnabled = false;
                //this.pointDraft = undefined;
                this.zoneDraft = { type: 'zone', owner: {} };
                this.map.removeLayer(this.activeShape);
                this.activeShape = {};
                this.sidebar.close();
                this.sidebar.enablePanel('new-zone');
                this.sidebar.disablePanel('edit-zone');
            }
        },*/
        /*cancelEdit() {
            // console.log('cancel edit');
            this.sidebar.close();
            this.editionEnabled = false;
            this.activeObject = undefined;
            this.pointDraft = undefined;
            this.contentDraft = { owner: {}, location: {} };
            this.sidebar.enablePanel('new-object');
            this.sidebar.disablePanel('edit-object');
        },*/

        /*checkTab(e) {
            console.log(e.id);
            if (
                e.id != 'edit-object' &&
                e.id != 'edit-zone' &&
                this.editionEnabled
            ) {
                // console.log('closing edition');
                this.editionEnabled = false;
                if (this.activeShape && this.isScape) {
                    this.map.removeLayer(this.activeShape);
                    this.activeShape = {};
                    this.sidebar.enablePanel('new-zone');
                    this.sidebar.disablePanel('edit-zone');
                } else {
                    this.activeObject = undefined;
                    this.pointDraft = undefined;
                    this.contentDraft = { owner: {}, location: {} };
                    this.sidebar.enablePanel('new-object');
                    this.sidebar.disablePanel('edit-object');
                }
            }
            
            if (e.id != 'active-session' && this.showActiveSession) {
                this.showActiveSession = false;
            }
            if (e.id != 'list-sessions' && this.showSessionList) {
                this.showSessionList = false;
            }
            if (e.id == 'settings' && this.showSettings) {
                if (
                    this.overlayImage &&
                    Object.keys(this.overlayImage).length > 0
                ) {
                    this.overlayImage.editing.enable();
                    this.overlayImage.select();
                }
            }
            if (e.id != 'settings' && this.showSettings) {
                if (
                    this.overlayImage &&
                    Object.keys(this.overlayImage).length > 0
                ) {
                    this.overlayImage.editing.disable();
                }
            }
            this.activeTab = e.id;
            // console.log('checkTab', e.id);
        },*/

        /*closeModal() {
            this.showObjectModal = false;
            this.activeObject = undefined;
        },*/
        /*closeSettings() {
            // console.log('closing settings');
            this.showSettings = false;
            if (this.overlayImage && this.overlayImage.length) {
                this.overlayImage.editing.disable();
            }
            this.sidebar.close();
        },*/
        closeUpdatedSettings() {
            // console.log('project updated');
            this.originalMapProvider = this.project.mapProvider;
            if (this.project.overlay) {
                // console.log('updating original overlay');
                this.originalOverlay = { ...this.project.overlay };
            }
            // console.log('closing settings');
            this.closeSettings();
        },
        discardSettingsChanges() {
            // console.log('discarding project changes');
            this.project.mapProvider = this.originalMapProvider.name;
            /*console.log(
                { ...this.project.overlay },
                this.originalOverlay,
                _.isEqual(this.project.overlay, this.originalOverlay)
            );*/
            if (!_.isEqual(this.project.overlay, this.originalOverlay)) {
                this.project.overlay = { ...this.originalOverlay };
                if (this.overlayImage) {
                    // console.log('redraw overlay', this.project.overlay);
                    this.map.removeLayer(this.overlayImage);

                    if (
                        this.originalOverlay.image &&
                        Object.keys(this.originalOverlay.image).length > 0
                    ) {
                        this.dawOverlayWithData(this.originalOverlay);
                    }
                }
            }

            this.closeSettings();
        },

        /*editSession(session) {
            // console.log('in edit session', session);
            this.sidebar.disablePanel('new-session');
            this.sidebar.enablePanel('edit-session');
            this.showObjectModal = false;
            this.creationEnabled = false;
            this.sidebar.close();
            // this.contentDraft = { ...this.activeObject };
            this.sessionEditionEnabled = true;
            this.activeSession = { ...session };
            setTimeout(() => {
                this.sidebar.open('edit-session');
            }, 500);
        },
        */
        /*cancelEditSession() {
            // console.log('cancel edit');
            this.sidebar.close();
            this.sessionEditionEnabled = false;
            this.activeSession = undefined;
            this.sidebar.enablePanel('new-session');
            this.sidebar.disablePanel('edit-session');
        },
        */

        updateProject(projectData) {
            if (this.project.type == 'scape') {
                // console.log("saving scape project")
                // console.log("has overlay",this.overlayImage)
                if (this.overlayImage) {
                    projectData.overlay.opacity = this.overlayOpacity;
                    projectData.overlay.angle = this.overlayImage.getAngle();
                    projectData.overlay.corners = this.overlayImage.getCorners();
                    projectData.overlay.center = this.overlayImage.getCenter();
                    // console.log("overlayImage",projectData.overlay);
                }

                //console.log(projectData);
            }
            this.$store
                .dispatch('updateProject', {
                    id: this.project._id,
                    project: projectData,
                })
                .then(() => {
                    this.closeUpdatedSettings();
                })
                .catch((e) => {
                    //show error
                    console.error(e);
                });
        },

        updateOverlayData(data) {
            // console.log('data', data);
            this.project.overlay.opacity = this.overlayOpacity;
            this.project.overlay.angle = this.overlayImage.getAngle();
            this.project.overlay.corners = this.overlayImage.getCorners();
            this.project.overlay.center = this.overlayImage.getCenter();
            // console.log('project radius', this.overlayImage.getAngle());
        },

        /* content */

        /* map */
        /*centerMap(event) {
            // console.log('event', event);
            if (event.type == 'zone') {
                if (event.shape.type == 'circle') {
                    this.map.fitBounds(
                        L.latLngBounds([
                            this.$options.filters.toLatLonFromArray(
                                event.shape.coordinates
                            ),
                        ])
                    );
                } else {
                    this.map.fitBounds(
                        L.latLngBounds(
                            this.$options.filters.toLatLonFromArray(
                                event.shape.coordinates
                            )
                        )
                    );
                }
            } else {
                this.map.fitBounds(
                    L.latLngBounds([
                        this.$options.filters.toLatLon(event.location),
                    ])
                );
            }

            this.openObject(event);
        },*/
        /*addPoint(pointData) {
            // console.log('adding point in coords', pointData.lat, pointData.lon);
            this.contentDraft.location = {
                latitude: pointData.lat,
                longitude: pointData.lon,
            };
            // console.log(this.contentDraft);
            this.pointDraft = {
                location: { latitude: pointData.lat, longitude: pointData.lon },
            };

            this.map.fitBounds(
                L.latLngBounds([
                    this.$options.filters.toLatLon(this.pointDraft.location),
                ])
            );

        },*/
        updatePoint(pointData) {
            // console.log(pointData);
            this.pointDraft = {
                location: { latitude: pointData.lat, longitude: pointData.lon },
            };
            this.map.fitBounds(
                L.latLngBounds([
                    this.$options.filters.toLatLon(this.pointDraft.location),
                ])
            );
        },
        updateDraftPosition(e) {
            // console.log(e.target._latlng);
            this.$emit('updatePointDraft', {
                location: {
                    latitude: e.target._latlng.lat,
                    longitude: e.target._latlng.lng,
                },
            })
            /*this.pointDraft = {
                location: {
                    latitude: e.target._latlng.lat,
                    longitude: e.target._latlng.lng,
                },
            };
            this.contentDraft.location = {
                latitude: e.target._latlng.lat,
                longitude: e.target._latlng.lng,
            };*/
        },
        /*activeMapPosition(e) {
            console.log("map position", this.$refs.editMap)
            this.mapPositionActive = e;

            if (this.mapPositionActive) {
                // console.log('adding class');
                this.$refs.editMap.$el.classList.add('map-workshop-cursor');
            }
        },*/
        getMapClickPosition(e) {
            // console.log("map position active? ", this.mapPositionActive)
            if (this.mapPositionActive) {
                // console.log('map click position', e.latlng);
                /*this.addPoint({ lat: e.latlng.lat, lon: e.latlng.lng });
                this.mapPositionActive = !this.mapPositionActive;
                this.$refs.editMap.$el.classList.remove('map-workshop-cursor');*/
                this.$emit('addPoint', { lat: e.latlng.lat, lon: e.latlng.lng });
                this.$refs.editMap.$el.classList.remove('map-workshop-cursor');
                //this.mapPositionActive = !this.mapPositionActive;
            }

            /*if (this.SWmapPositionActive) {
                this.SWaddPoint({ lat: e.latlng.lat, lon: e.latlng.lng });
                this.SWmapPositionActive = !this.SWmapPositionActive;
                this.$refs.editMap.$el.classList.remove('map-workshop-cursor');
            }

            if (this.NEmapPositionActive) {
                this.NEaddPoint({ lat: e.latlng.lat, lon: e.latlng.lng });
                this.NEmapPositionActive = !this.NEmapPositionActive;
                this.$refs.editMap.$el.classList.remove('map-workshop-cursor');
            }*/
        },

        updateOpacity(opacity) {
            this.overlayOpacity = opacity;
        },

        addOverlayImage(image) {
            // console.log('adding image', image);
            this.project.overlay.image = image;
            this.overlayImage = L.distortableImageOverlay(image.url, {
                selected: true,
                suppressToolbar: true,
                mode: 'freeRotate',
                actions: [L.FreeRotateAction],
            }).addTo(this.map);
            /*this.overlayImage.on('update', function (e) {
                //console.log(e, this._image.style.opacity);
            });*/
            // console.log(this.overlayImage);
        },
        updateOverlayImage(e) {
            // console.log('updating image', e);
            this.map.removeLayer(this.overlayImage);
            this.overlayOpacity = 100;
            this.project.overlay.opacity = this.overlayOpacity;
            this.addOverlayImage(e);
        },
        removeOverlayImage() {
            // console.log('removing image');
            this.project.overlay.image = {};
            this.overlayOpacity = 100;
            this.project.overlay.opacity = this.overlayOpacity;
            this.map.removeLayer(this.overlayImage);
        },
        dawOverlayWithData(data) {
            // console.log(data);
            this.overlayImage = L.distortableImageOverlay(data.image.url, {
                selected: false,
                suppressToolbar: true,
                mode: 'freeRotate',
                actions: [L.FreeRotateAction],
            }).addTo(this.map);
            setTimeout(() => {
                this.overlayImage.setCorners(data.corners);
                this.overlayImage.setAngle(data.angle);
                this.overlayImage._image.style.opacity =
                    this.overlayOpacity / 100;
                this.overlayImage.editing.disable();
            }, 200);

            // this.drawOverlayImage = true;
        },

        drawCircle() {
            // console.log('drawing circle');
            this.map.editTools.startCircle();
            // console.log(this.activeShape);
        },
        drawPolygon() {
            // console.log('drawing polygon');
            this.map.editTools.startPolygon();
        },
        drawRectangle() {
            // console.log('drawing rectangle');
            this.map.editTools.startRectangle();
        },
        removeShape() {
            this.map.removeLayer(this.activeShape);
            this.activeShape = {};
        },

        initActiveShape(e) {
            // console.log('initActiveShape', e);

            this.activeShape = {};
        },

        setActiveShape(e) {
            // console.log('setActiveShape', e);

            this.activeShape = e.layer;
        },

        canDrawPolygon(object) {
            /*console.log(
                'canDrawPolygon',
                object.shape.type == 'polygon' &&
                    (!this.activeObject || object._id != this.activeObject._id)
            );*/

            if (object.shape.type == 'polygon') {
                if (!this.activeObject && !this.editionEnabled) {
                    /*console.log(
                        'no active object and edition enabled for',
                        object.title
                    );*/
                    return true;
                } else if (
                    this.activeObject &&
                    object._id != this.activeObject._id
                ) {
                    /*console.log(
                        'active object with different id',
                        object._id,
                        this.activeObject._id
                    );*/
                    return true;
                } else if (!this.editionEnabled) {
                    // console.log('no edition enabled');
                    return true;
                }
                return false;
            }
            /*return (
                object.shape.type == 'polygon' &&
                (!this.activeObject || object._id != this.activeObject._id)
            );*/
            /*object.shape.type == 'polygon' &&
                                    (!activeObject ||
                                        object._id != activeObject._id)
                                "*/
        },

        /* map */

        goToViewMode() {
            this.$router.push({
                name: 'project-view',
                params: { projectId: this.project._id },
            });
        },

        showSettingsWizard() {
            this.settingsWizardEnabled = !this.settingsWizardEnabled;
        },

        onChangeReceived(e) {
            // console.log("on change recived")
            const data = JSON.parse(e.data);
            switch (data.type) {
                case 'UPDATE':
                case 'NEW_COMMENT':
                    this.$store.commit('UPDATE_OBJECT', data.object);
                    break;
                case 'CREATE':
                    this.$store.commit('ADD_OBJECT_TO_PROJECT', data.object);
                    break;
                case 'NEW_PROJECT_COMMENT':
                    this.$store.commit('ADD_COMMENT_TO_PROJECT', data.object);
                    break;
                case 'LIKE_PROJECT_COMMENT':
                    this.$store.commit('UPDATE_COMMENT', {
                        _id: data.object._id,
                        comment: data.object,
                    });
                    break;
                case 'NEW_PROJECT_CHANGE':
                    this.$store.commit('ADD_CHANGE_TO_PROJECT', data.object);
                    break;
                case 'DELETE_OBJECT':
                    this.$store.commit('DELETE_OBJECT', data.object);
                    break;
                case 'NEW_ACTIVE_SESSION':
                    this.$store.commit('ADD_ACTIVE_SESSION_TO_PROJECT', data.object);
                    if (this.project.activeSession && !this.session.length) {
                        this.fetchSession();
                    }
                    break;
                case 'PAUSE_ACTIVE_SESSION':
                    if (this.session && !this.session.isPaused) {
                        this.fetchSession();
                    }
                    break;
                case 'CONTINUE_ACTIVE_SESSION':
                    if (this.session && this.session.isPaused) {
                        this.fetchSession();
                    }

                    break;
                case 'REMOVE_ACTIVE_SESSION':
                    this.$store.commit('REMOVE_ACTIVE_SESSION_TO_PROJECT');
                    if (this.session) {
                        this.session = {};
                        this.$store.dispatch('cleanSession');
                    }

                    break;
                default:
                    console.log('unhandled event ', data.type || data.message);
            }
        },
    },
};
</script>


<style scoped lang="css">
@import '~leaflet/dist/leaflet.css';
@import '~tippy.js/dist/tippy.css';
@import '../assets/css/tippylabylok.css';
@import '~leaflet-distortableimage/dist/vendor.css';
@import '~leaflet-distortableimage/dist/leaflet.distortableimage.css';
@import '../assets/css/map-sidebar.css';

.full-width-map{
    width: 100vw;
}
</style>
